<div class="d-flex justify-content-between  user-b mb-1 flex-wrap">
  <div class="search-cont mt-4 ">
    <div class="s-in form-input" style="position:relative">
      <mat-icon class="input-icon">search</mat-icon>
      <input type="text" placeholder="Search" class="form-control" [(ngModel)]="searchInput"
        (input)="onSearch($event)" />
    </div>
  </div>
  <button mat-raised-button color="primary" class="primary-btn mt-4" type="submit"
    (click)="onAddEdit('add','')"><i class="fas fa-plus"></i> Add New </button>
</div>
<div class="table-container flex-grow-1 ">
  <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="dataSource.data.length!=0">
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef>
        {{"COMMON.CATEGORY"|translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.j_c }} </td>
    </ng-container>
    <ng-container matColumnDef="sub_category">
      <th mat-header-cell *matHeaderCellDef>
        <div style="max-width: 500px" class="text-center">
          {{"COMMON.SUBCATEGORY"|translate}} & {{"COMMON.WAGES"|translate}}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div style="max-width: 500px;">
          <div class="d-flex align-items-center justify-content-end cat-box" *ngFor="let item of element.sub_category; let i = index"  [ngClass]="{'mt-3':i!=0}">
            <div class="me-3">{{item.j_sc}}</div>
            <div class="me-3">
              <input type="number" min="0" class="form-control" [(ngModel)]="item.wages">
              <mat-error>{{item.error}}</mat-error>
            </div>
            <div>
              <button mat-raised-button color="warn" class="auth-form-btn  success-btn " type="submit" (click)="onSaveWages(item)">{{"BUTTON.SAVE" | translate}}</button>
            </div>
          </div>
        </div>
     
        {{element.dep }}
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION" | translate}}</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex">
          <div class="action-btn me-2" matTooltip="View" (click)="onAddEdit('edit',element)">
            <img src="assets/images/icons/edit-icon.svg" class="img-fluid" alt="">
          </div>
          <div class="action-btn  cursor-pointer" matTooltip="Edit" (click)="onDeleteItem(element.id)">
            <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div class="mat-table__message" *ngIf="dataSource.data.length==0">
    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
  </div>
</div>
<div class="pagination-cont" *ngIf="dataSource.data.length!=0">
  <div class="show-item">
    {{"COMMON.SIP" | translate}}
    <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
      <option [value]="item" *ngFor="let item of pageSizeOptions">
        {{ item }}
      </option>
    </select>
  </div>
  <div class="page-c">
    <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
      [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
  </div>
</div>